import React from "react";
import HeroSection from "../../../components/general/HomeLayout/HeroSection/Herosection";
import ApplySection from "../../../components/general/HomeLayout/ApplySection/ApplySection";
import AITutor from "../../../components/general/HomeLayout/AITutorSection/AITutor";
import MentorshipMatching from "../../../components/general/HomeLayout/MentorshipMatchingSection/MentorshipMatching";
import MentorsShowcase from "../../../components/general/HomeLayout/MentorsShowcaseSection/MentorsShowcase";
import CodeChallenge from "../../../components/general/HomeLayout/CodeChallengeSection/CodeChallenge";
import RoadmapGuidelines from "../../../components/general/HomeLayout/RoadmapGuidelines/RoadmapGuidelines";
import Courses from "../../../components/general/HomeLayout/Courses/Courses";
import Statistics from "../../../components/general/HomeLayout/Statistics/Statistics";
import StudentSuccessStories from "../../../components/student/StudentSuccess/Studentsuccessstories";
import MostTrustedMentors from "../../../components/student/TrustedMentors/Trustedmentors";  

const Home = () => {

  return (
    <>
      <HeroSection />
      <StudentSuccessStories />
      <MentorsShowcase />
      <MostTrustedMentors />
      <AITutor />
      <RoadmapGuidelines />
      <Courses />
      <CodeChallenge />
      <MentorshipMatching />
      <Statistics />
      <ApplySection />
    </>
  );
};

export default Home;
